import "./styles.scss";
import React, { useState, useEffect } from "react";
import logo from "assets/images/home-logo.png";
import {
	Collapse,
	Container,
	DropdownMenu,
	DropdownToggle,
	Nav,
	NavLink,
	Navbar,
	NavbarBrand,
	NavbarToggler,
	NavItem,
	UncontrolledDropdown,
	DropdownItem,
	// Offcanvas,
	// OffcanvasBody,
	// OffcanvasHeader,
} from "reactstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, withRouter, useLocation } from "react-router-dom";
import "assets/scss/website/app.scss";
import { withTranslation } from "react-i18next";
import AuthCard from "../../Cards/AuthCard";
import { useSelector, useDispatch } from "react-redux";
import { authenticate, setCurrencyRed } from "store/Auth/actions";
import { logout } from "store/Auth/actions";
// import NotificationsCountService from "services/Website/NotificationsCountService";
import AuthService, { logoutFn } from "services/Website/AuthService";
import { useTranslation } from "react-i18next";
import { resetLangFilters } from "store/filter/actions";
import user1 from "../../../../assets/images/users/user_logo.jpeg";
import favImage from "assets/images/website/navIcons/heart.png";
import langImage from "assets/images/website/navIcons/language.png";
import changeImage from "assets/images/website/navIcons/currency.png";
import imgLocation from "assets/images/location.svg";
import imgCall from "assets/images/call.svg";
import imgEmail from "assets/images/email.svg";
import HomeService from "services/Website/HomeService";
import { toast } from "react-toastify";

const languages = [
	{ name: "English", code: "en" },
	{ name: "Русский", code: "ru" },
	{ name: "العربية", code: "ar", dir: "rtl" },
	{ name: "中国人", code: "zh" },
];
const Header = (props) => {
	const { t, i18n } = useTranslation();

	const AuthData = useSelector((state) => state.Auth);
	const [isOpenMenu, setisOpenMenu] = useState(false);
	const [searchCurrency, setSearchCurrency] = useState("");
	const [currentCurrency, setCurrentCurrency] = useState("");
	const handleClose = () => setShow(false);
	const { pathname } = useLocation();
	const dispatch = useDispatch();
	let currentLocale = localStorage.getItem("meras_lang") || "en";
	let currencySlected = AuthData.currency;
	const [language, setLanguage] = useState(currentLocale);
	const [currenciesOptions, setCurrenciesOptions] = useState([]);
	const [currenciesAllOptions, setCurrenciesAllOptions] = useState([]);
	const [firstOption, setFirstOption] = useState(null);
	const homeService = new HomeService();

	useEffect(() => {
		Promise.all([
			homeService.getCurrencies(),
			homeService.getUserLocationCurrency(),
		]).then((res) => {
			if (res[0]?.status) {
				setCurrenciesAllOptions(res[0]?.data);
			}
			if (res[1]?.status) {
				let firstOpt = res[0]?.data?.find(
					(cur) => cur?.currency_code === res[1]?.data
				);
				setFirstOption(firstOpt);
			}
		});
		// homeService.getUserCurrency().then(res=> {
		//   if(res?.status){
		//     setCurrentCurrency(currenciesAllOptions?.find(cur => cur?.currency_code === res?.data))
		//     let curr = JSON.parse(localStorage?.getItem('merasCurrency'))
		//     if(!!curr){
		//       dispatch(setCurrencyRed(curr))
		//     } else {
		//       dispatch(setCurrencyRed(currenciesAllOptions?.find(cur => cur?.currency_code === res?.data)))
		//     }
		//   }
		// })
		// }
	}, []);

	useEffect(() => {
		if (!!currenciesAllOptions?.length && !!firstOption) {
			Promise.all([homeService.getUserCurrency()]).then((res) => {
				let secondOption;
				if (res[0]?.status) {
					secondOption = currenciesAllOptions?.find(
						(cur) => cur?.currency_code === res[0]?.data
					);
					setCurrentCurrency(secondOption);
					dispatch(setCurrencyRed(secondOption));
					let filterCurrencies = currenciesAllOptions.filter(
						(obj) =>
							obj.currency_code !== firstOption?.currency_code ||
							obj.currency_code !== secondOption?.currency_code
					);
					setCurrenciesOptions(
						[firstOption, secondOption, ...filterCurrencies].filter(
							(item, index, self) =>
								index ===
								self.findIndex((t) => t.currency_code === item.currency_code)
						)
					);
				}
			});
		}
	}, [currenciesAllOptions, firstOption]);

	const handleShow = () => {
		setShow(true);
	};
	const toggle = () => setisOpenMenu(!isOpenMenu);
	const handleValidSubmit = async (e, values) => {
		e.preventDefault();
		props.history.push(`products?keyword=${values.keyword}`);
	};
	const getAuthData = () => {
		const authJson = localStorage.getItem("auth");
		const userData = JSON.parse(authJson);
		return userData;
	};

	const changeCurrency = (currencySele) => {
		let data = {
			default_currency: currencySele?.currency_code,
		};
		if (AuthData.token && AuthData.userType === "user") {
			homeService.setUserCurrency(data).then((res) => {
				if (res?.status) {
					toast.success("Currency Changed Successfully.");
					dispatch(resetLangFilters());
					dispatch(setCurrencyRed(currencySele));
					setSearchCurrency("");
				}
			});
		} else {
			homeService.setCurrency(data).then((res) => {
				if (res?.status) {
					toast.success("Currency Changed Successfully.");
					dispatch(resetLangFilters());
					dispatch(setCurrencyRed(currencySele));
					setSearchCurrency("");
				}
			});
		}
	};

	const changeCurrencyLogout = () => {
		AuthService.logout();
		dispatch(logout());
		logoutFn();

		// currencySele
		// let data = {
		//   default_currency: currencySele?.currency_code
		// }

		// homeService.setCurrency(data).then(res=>{
		//     if(res?.status){
		//       dispatch(resetLangFilters())
		//       dispatch(setCurrencyRed(currencySele))
		//       props.history.push('/')
		//     }
		// })
	};

	const checkAuth = () => {
		if (AuthData.token && AuthData.userType === "user") {
			props?.history.push(`/profile/interests`);
		} else {
			dispatch(authenticate({ navigateTo: `/profile/interests` }));
			props?.history.push(`/login`, {
				navigateTo: `/profile/interests`,
			});
		}
	};

	return (
		<React.Fragment>
			<div className="navWebsite">
				<div className="headerGenereal">
					<Container>
						<Navbar expand="lg" className="p-0">
							<Link to="/">
								<img
									src={logo}
									height={64}
									width={64}
									className="img-fluid p-0"
								/>
							</Link>
							<NavbarToggler
								className="border-0"
								onClick={() => setisOpenMenu(true)}
							/>
							<Collapse navbar>
								<div
									className="me-auto header-collapse w-100"
									style={{
										paddingRight: AuthData.lang === "ar" ? "2rem" : "0",
										paddingLeft: AuthData.lang !== "ar" ? "2rem" : "0",
									}}>
									<Nav navbar className="d-flex align-items-center">
										<div className="nav-links">
											{/* About Us */}
											<NavItem>
												<Link
													to="/about-us"
													style={{
														fontWeight: pathname === "/about-us" ? 600 : 400,
													}}>
													{t("About Us")}
												</Link>
											</NavItem>
											{/* Compounds */}
											<NavItem>
												<NavLink>
													<Link
														to="/resales"
														style={{
															fontWeight:
																pathname === "/resales" ||
																pathname === "/compounds"
																	? 600
																	: 400,
														}}>
														{t("Compounds")}
													</Link>
												</NavLink>
											</NavItem>
											{/* Contact Us */}
											<NavItem>
												<NavLink>
													<Link
														to="/contact-us"
														style={{
															fontWeight:
																pathname === "/contact-us" ? 600 : 400,
														}}>
														{t("Contact Us")}
													</Link>
												</NavLink>
											</NavItem>
										</div>

										<div className="d-flex ms-auto content-gap">
											{/* <NavItem >
                    <NavLink>
                      <Link to="/"
                        style={{ color: pathname === "/" ? "var(--primary-color)" : "#1D1D1B", fontWeight: pathname === "/compounds" ? 600 : 400 }}
                      ><img src={changeImage} alt=""/></Link>
                    </NavLink>
                  </NavItem> */}
											<div
												className="d-flex align-items-center"
												style={{ gap: "12px" }}>
												<button className="btn p-0" onClick={() => checkAuth()}>
													<img
														src={favImage}
														width={32}
														className="img-fluid"
													/>
												</button>
												<UncontrolledDropdown inNavbar nav>
													<DropdownToggle className="mt-2 p-0" caret nav>
														<img
															src={changeImage}
															width={32}
															className="p-0"
															alt=""
														/>
													</DropdownToggle>
													<DropdownMenu
														right
														className="custom-dropdown currency">
														<input
															type="text"
															value={searchCurrency}
															onChange={(e) =>
																setSearchCurrency(e.target?.value)
															}
															placeholder="Search Currency"
														/>
														{currenciesOptions
															?.filter((currency) =>
																currency?.currency_name
																	?.toLowerCase()
																	?.includes(searchCurrency)
															)
															?.map((currency, index) => {
																return (
																	<DropdownItem
																		key={index}
																		className={`${
																			currencySlected?.currency_code ===
																			currency?.currency_code
																				? "active-currency"
																				: ""
																		}`}
																		onClick={() => {
																			changeCurrency(currency);
																		}}>
																		{currency.currency_name}
																	</DropdownItem>
																);
															})}
													</DropdownMenu>
												</UncontrolledDropdown>
												<UncontrolledDropdown inNavbar nav>
													<DropdownToggle className="mt-2 p-0" caret nav>
														<img
															src={langImage}
															width={32}
															className="p-0"
															alt=""
														/>
													</DropdownToggle>
													<DropdownMenu right className="language-dropdown">
														{languages.map((lang, index) => {
															return (
																<DropdownItem
																	key={index}
																	className={`${
																		lang?.code === AuthData?.lang
																			? "active"
																			: ""
																	}`}
																	onClick={() => {
																		// http.setLang(lang.code)
																		dispatch(resetLangFilters());
																		i18n.changeLanguage(lang.code);
																		dispatch(
																			authenticate({
																				lang: lang.code,
																			})
																		);
																	}}>
																	{lang.name}
																</DropdownItem>
															);
														})}
													</DropdownMenu>
												</UncontrolledDropdown>
											</div>

											<div className="custom-nav custom-dropdown ">
												<NavLink>
													<Link
														className={
															pathname === "/advanced-filter" ||
															pathname === "/compare-list"
																? "active-link"
																: ""
														}
														to="/advanced-filter">
														{t("compare")}
													</Link>
												</NavLink>
												<NavLink>
													<Link
														className={
															pathname !== "/create-resale" &&
															pathname !== "/advanced-filter" &&
															pathname !== "/compare-list"
																? "active-link"
																: ""
														}
														to="/">
														{t("Buy")}
													</Link>
												</NavLink>
												<NavLink>
													<Link
														className={
															pathname === "/create-resale" ? "active-link" : ""
														}
														to="/create-resale">
														{t("Sell")}
													</Link>
												</NavLink>
											</div>
											{/* <NavItem>
												<NavLink>
													<button className="btn" onClick={() => {
                        if (AuthData.token && AuthData.userType === "user") {
                          props.history.push("/create-resale")
                        } else {
                          dispatch(authenticate({ navigateTo: `/create-resale` }))
                          setModal(true)
                        }
                      }}  >
                        {t("Sell My Property")}
                      </button> 
												</NavLink>
											</NavItem>*/}

											{AuthData.token && AuthData.userType === "user" ? (
												<UncontrolledDropdown
													className="d-flex align-items-center fw-bold"
													inNavbar
													nav>
													<DropdownToggle caret nav>
														{/* <img
															className="rounded-circle p-0 mx-1"
															src={user1}
															alt="Header Avatar"
															width="28px"
															height="28px"
														/> */}
														{/* <i className="far fa-user fa-lg mt-2 pt-1" style={{marginRight: '4px'}} ></i> */}
														<span className="text-primary bask-font font-size-22">
															{AuthData.user_name}
															<i
																className="fa fa-chevron-down fa-lg font-size-14"
																style={{ marginLeft: "30px" }}></i>
														</span>
													</DropdownToggle>
													<DropdownMenu right className="profile-dropdown">
														<DropdownItem
															onClick={() => props.history.push("/profile")}>
															<Link
																to="/profile"
																style={{ color: "var(--primary-color)" }}>
																{t("Profile")}
															</Link>
														</DropdownItem>
														<DropdownItem divider />
														<DropdownItem
															onClick={() => {
																changeCurrencyLogout();
															}}>
															{t("logout")}
														</DropdownItem>
													</DropdownMenu>
												</UncontrolledDropdown>
											) : (
												<div>
													<Link
														to={{ pathname: `/login`, state: "signin" }}
														className="bask-font btn px-3 fw-bold font-size-18 rounded-pill"
														style={{
															height: "40px",
															lineHeight: "1.5",
															fontStyle: "italic",
															color: "var(--primary-color)",
														}}>
														{t("SignIn")}
													</Link>
													<Link
														to={{ pathname: `/login`, state: "signup" }}
														state="signup"
														className="bask-font btn px-2 fw-bold font-size-18 rounded-pill"
														style={{
															height: "40px",
															lineHeight: "1.5",
															fontStyle: "italic",
															color: "var(--primary-color)",
														}}>
														{t("SignUp")}
													</Link>
												</div>
											)}
										</div>
									</Nav>
								</div>
							</Collapse>
						</Navbar>
						<Offcanvas
							style={{
								background: "var(--body-bg)",
							}}
							show={isOpenMenu}
							onHide={() => setisOpenMenu(false)}>
							<Offcanvas.Header closeButton>
								<img
									src={logo}
									alt=""
									width={45}
									height={45}
									className="img-fluid img-new-logo"
								/>
							</Offcanvas.Header>
							<Offcanvas.Body className="navbarDashboard">
								<Nav className="me-auto" navbar>
									<NavItem>
										<Link to={`/`} className="nav-link">
											{t("Home")}
										</Link>
									</NavItem>
									<NavItem>
										<Link to={`/resales`} className="nav-link">
											{t("Find Your Property")}
										</Link>
									</NavItem>
									<NavItem>
										<Link to={`/contact-us`} className="nav-link">
											{t("Contact Us")}
										</Link>
									</NavItem>
									<NavItem>
										<Link to={`/advanced-filter`} className="nav-link">
											{t("compare")}
										</Link>
									</NavItem>
									<NavItem>
										<Link to={`/create-resale`} className="nav-link">
											{t("Sell")}
										</Link>
									</NavItem>
									<NavItem>
										<Link to={`/about-us`} className="nav-link">
											{t("About Us")}
										</Link>
									</NavItem>
									<div className="group-icons-header">
										<NavItem>
											<Link to="/">
												<button className="btn p-0">
													<img
														src={changeImage}
														className="nav-link header-icons"
														alt=""
													/>
												</button>
											</Link>
										</NavItem>
										<NavItem>
											<Link to="/">
												<button
													className="btn p-0"
													onClick={() => {
														if (
															AuthData.token &&
															AuthData.userType === "user"
														) {
															props.history.push("/profile/interests");
														} else {
															dispatch(
																authenticate({
																	navigateTo: `/profile/interests`,
																})
															);
														}
													}}>
													<img
														src={favImage}
														className="img-fluid header-icons"
													/>
												</button>
											</Link>
										</NavItem>
										<UncontrolledDropdown inNavbar nav className="m-0">
											<DropdownToggle caret nav className="m-0">
												<img src={langImage} className="header-icons" alt="" />
											</DropdownToggle>
											<DropdownMenu right>
												{languages.map((lang, index) => {
													return (
														<DropdownItem
															key={index}
															onClick={() => {
																// http.setLang(lang.code)
																dispatch(resetLangFilters());
																i18n.changeLanguage(lang.code);
																dispatch(
																	authenticate({
																		lang: lang.code,
																	})
																);
															}}>
															{lang.name}
														</DropdownItem>
													);
												})}
											</DropdownMenu>
										</UncontrolledDropdown>
									</div>
									{AuthData.token && AuthData.userType === "user" ? (
										<UncontrolledDropdown inNavbar nav>
											<DropdownToggle caret nav>
												<img
													className="rounded-circle header-profile-user p-0 me-2"
													src={user1}
													alt="Header Avatar"
												/>
												{AuthData.user_name}
												<i
													className="fa fa-chevron-down fa-lg font-size-14"
													style={{ marginLeft: "4px" }}></i>
											</DropdownToggle>
											<DropdownMenu right>
												<DropdownItem
													onClick={() => props.history.push("/profile")}>
													<Link
														to="/profile"
														style={{ color: "var(--primary-color)" }}>
														{t("Profile")}
													</Link>
												</DropdownItem>
												<DropdownItem divider />
												<DropdownItem
													onClick={() => {
														changeCurrencyLogout();
													}}>
													{t("logout")}
												</DropdownItem>
											</DropdownMenu>
										</UncontrolledDropdown>
									) : (
										<Link
											to={`/login`}
											className="btn bask-font mt-2 text-primary px-5 fw-bold font-size-14 rounded-pill"
											style={{
												height: "40px",
												background: "none",
												color: "#ffffff",
												border: "solid 1px var(--primary-color)",
												boxShadow: ".1px .2px ",
												borderRadius: "8px",
												boxShadow: "0 3px 8px 0 rgba(21, 131, 242, 0.16)",
											}}>
											{t("Sign in")}
										</Link>
									)}
								</Nav>
							</Offcanvas.Body>
						</Offcanvas>
					</Container>
				</div>
			</div>
		</React.Fragment>
	);
};

export default withRouter(withTranslation()(Header));
